/* tslint:disable */

declare var Object: any;
export interface ViewemployeeInterface {
  "empId": string;
  "firstName": string;
  "middleName": string;
  "lastName": string;
  "fullName"?: string;
  "gender": number;
  "userId"?: number;
  "taxno": string;
  "geocoord"?: string;
  "status": number;
  "reqStatus": number;
  "lastreqno"?: string;
  "email"?: string;
  "photo": string;
  "phone"?: string;
  "birthplace"?: string;
  "birthdate"?: Date;
  "maritalstatus"?: number;
  "address"?: string;
  "cityId"?: number;
  "stateId"?: number;
  "countryId"?: number;
  "zipcode"?: string;
  "companyId": number;
  "empNo": string;
  "startDate": Date;
  "endDate"?: Date;
  "isMain": number;
  "empcompanyStatus"?: number;
  "gradeCode": string;
  "employCode": string;
  "costCode": string;
  "spvParent"?: string;
  "spvPos"?: number;
  "spvPath"?: string;
  "spvLevel"?: number;
  "mgrParent"?: string;
  "mgrPos"?: number;
  "mgrPath"?: string;
  "mgrLevel"?: number;
  "positionId": number;
  "posCode": string;
  "parentId": number;
  "posNameEn": string;
  "posNameId": string;
  "posNameMy": string;
  "posNameTh": string;
  "jobstatuscode"?: string;
  "posLevel": number;
  "parentPath": string;
  "posFlag": number;
  "deptId": number;
  "dorder": number;
  "jobtitleCode"?: string;
  "reportTopos"?: number;
  "clevel"?: number;
  "corder"?: number;
  "changeflag"?: string;
  "reportPostype"?: string;
  "deptCode"?: string;
  "gradeOrder"?: number;
  "gradeCategory"?: string;
  "worklocationCode": string;
}

export class Viewemployee implements ViewemployeeInterface {
  "empId": string;
  "firstName": string;
  "middleName": string;
  "lastName": string;
  "fullName": string;
  "gender": number;
  "userId": number;
  "taxno": string;
  "geocoord": string;
  "status": number;
  "reqStatus": number;
  "lastreqno": string;
  "email": string;
  "photo": string;
  "phone": string;
  "birthplace": string;
  "birthdate": Date;
  "maritalstatus": number;
  "address": string;
  "cityId": number;
  "stateId": number;
  "countryId": number;
  "zipcode": string;
  "companyId": number;
  "empNo": string;
  "startDate": Date;
  "endDate": Date;
  "isMain": number;
  "empcompanyStatus": number;
  "gradeCode": string;
  "employCode": string;
  "costCode": string;
  "spvParent": string;
  "spvPos": number;
  "spvPath": string;
  "spvLevel": number;
  "mgrParent": string;
  "mgrPos": number;
  "mgrPath": string;
  "mgrLevel": number;
  "positionId": number;
  "posCode": string;
  "parentId": number;
  "posNameEn": string;
  "posNameId": string;
  "posNameMy": string;
  "posNameTh": string;
  "jobstatuscode": string;
  "posLevel": number;
  "parentPath": string;
  "posFlag": number;
  "deptId": number;
  "dorder": number;
  "jobtitleCode": string;
  "reportTopos": number;
  "clevel": number;
  "corder": number;
  "changeflag": string;
  "reportPostype": string;
  "deptCode": string;
  "gradeOrder": number;
  "gradeCategory": string;
  "worklocationCode": string;
  constructor(data?: ViewemployeeInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Viewemployee`.
   */
  public static getModelName() {
    return "Viewemployee";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Viewemployee for dynamic purposes.
  **/
  public static factory(data: ViewemployeeInterface): Viewemployee{
    return new Viewemployee(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Viewemployee',
      plural: 'Viewemployees',
      path: 'Viewemployees',
      properties: {
        "empId": {
          name: 'empId',
          type: 'string'
        },
        "firstName": {
          name: 'firstName',
          type: 'string'
        },
        "middleName": {
          name: 'middleName',
          type: 'string'
        },
        "lastName": {
          name: 'lastName',
          type: 'string'
        },
        "fullName": {
          name: 'fullName',
          type: 'string'
        },
        "gender": {
          name: 'gender',
          type: 'number'
        },
        "userId": {
          name: 'userId',
          type: 'number'
        },
        "taxno": {
          name: 'taxno',
          type: 'string'
        },
        "geocoord": {
          name: 'geocoord',
          type: 'string'
        },
        "status": {
          name: 'status',
          type: 'number'
        },
        "reqStatus": {
          name: 'reqStatus',
          type: 'number'
        },
        "lastreqno": {
          name: 'lastreqno',
          type: 'string'
        },
        "email": {
          name: 'email',
          type: 'string'
        },
        "photo": {
          name: 'photo',
          type: 'string'
        },
        "phone": {
          name: 'phone',
          type: 'string'
        },
        "birthplace": {
          name: 'birthplace',
          type: 'string'
        },
        "birthdate": {
          name: 'birthdate',
          type: 'Date'
        },
        "maritalstatus": {
          name: 'maritalstatus',
          type: 'number'
        },
        "address": {
          name: 'address',
          type: 'string'
        },
        "cityId": {
          name: 'cityId',
          type: 'number'
        },
        "stateId": {
          name: 'stateId',
          type: 'number'
        },
        "countryId": {
          name: 'countryId',
          type: 'number'
        },
        "zipcode": {
          name: 'zipcode',
          type: 'string'
        },
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "empNo": {
          name: 'empNo',
          type: 'string'
        },
        "startDate": {
          name: 'startDate',
          type: 'Date'
        },
        "endDate": {
          name: 'endDate',
          type: 'Date'
        },
        "isMain": {
          name: 'isMain',
          type: 'number'
        },
        "empcompanyStatus": {
          name: 'empcompanyStatus',
          type: 'number'
        },
        "gradeCode": {
          name: 'gradeCode',
          type: 'string'
        },
        "employCode": {
          name: 'employCode',
          type: 'string'
        },
        "costCode": {
          name: 'costCode',
          type: 'string'
        },
        "spvParent": {
          name: 'spvParent',
          type: 'string'
        },
        "spvPos": {
          name: 'spvPos',
          type: 'number'
        },
        "spvPath": {
          name: 'spvPath',
          type: 'string'
        },
        "spvLevel": {
          name: 'spvLevel',
          type: 'number'
        },
        "mgrParent": {
          name: 'mgrParent',
          type: 'string'
        },
        "mgrPos": {
          name: 'mgrPos',
          type: 'number'
        },
        "mgrPath": {
          name: 'mgrPath',
          type: 'string'
        },
        "mgrLevel": {
          name: 'mgrLevel',
          type: 'number'
        },
        "positionId": {
          name: 'positionId',
          type: 'number'
        },
        "posCode": {
          name: 'posCode',
          type: 'string'
        },
        "parentId": {
          name: 'parentId',
          type: 'number'
        },
        "posNameEn": {
          name: 'posNameEn',
          type: 'string'
        },
        "posNameId": {
          name: 'posNameId',
          type: 'string'
        },
        "posNameMy": {
          name: 'posNameMy',
          type: 'string'
        },
        "posNameTh": {
          name: 'posNameTh',
          type: 'string'
        },
        "jobstatuscode": {
          name: 'jobstatuscode',
          type: 'string'
        },
        "posLevel": {
          name: 'posLevel',
          type: 'number'
        },
        "parentPath": {
          name: 'parentPath',
          type: 'string'
        },
        "posFlag": {
          name: 'posFlag',
          type: 'number'
        },
        "deptId": {
          name: 'deptId',
          type: 'number'
        },
        "dorder": {
          name: 'dorder',
          type: 'number'
        },
        "jobtitleCode": {
          name: 'jobtitleCode',
          type: 'string'
        },
        "reportTopos": {
          name: 'reportTopos',
          type: 'number'
        },
        "clevel": {
          name: 'clevel',
          type: 'number'
        },
        "corder": {
          name: 'corder',
          type: 'number'
        },
        "changeflag": {
          name: 'changeflag',
          type: 'string'
        },
        "reportPostype": {
          name: 'reportPostype',
          type: 'string'
        },
        "deptCode": {
          name: 'deptCode',
          type: 'string'
        },
        "gradeOrder": {
          name: 'gradeOrder',
          type: 'number'
        },
        "gradeCategory": {
          name: 'gradeCategory',
          type: 'string'
        },
        "worklocationCode": {
          name: 'worklocationCode',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Viewemployee.ts